import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const rhm = axios.create({ baseURL: `${BASE}/api/rhm`, withCredentials: true });
export const legacy = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

const attach = (cfg) => {
    const token = localStorage.getItem("rhm_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
};
rhm.interceptors.request.use(attach);
legacy.interceptors.request.use(attach);

export function apiError(e) {
    const detail = e?.response?.data?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
    if (detail?.msg) return detail.msg;
    return e?.message || "Something went wrong";
}

export const money = (n) =>
    n === null || n === undefined || n === ""
        ? "—"
        : new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(n);

export const dt = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const dOnly = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { dateStyle: "medium" }) : "—");
export const titleCase = (s = "") => s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
